module.exports = __webpack_public_path__ + "media/images/emblems/Landiswil-coat_of_arms-81b22500aee710c5c4560ca184392786.svg";